import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "rent_orders",
        object: "rent_order",
        header: [
            { text: "Precio", value: "price" },
            { text: "Tiempo", value: "time_quantity" },
            { text: "Desde", value: "date_time_from" },
            { text: "Hasta", value: "date_time_to" },
            { text: "Estado", value: "status" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
